var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useState } from 'react';
import { useBreakpoint } from '@rakutenfrance/breakpoint';
import { Drawer } from '@rakutenfrance/mui';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AvailableContent, UnavailableContent } from '../../components';
import { EconomicOperatorContextProvider, useEconomicOperatorContext } from '../../contexts';
import { DataForEconomicOperatorSellerApi } from '../../services/legal-economic-operator-api/codegenClient';
import { QueryClientProvider, useQuery, QueryClient } from '@tanstack/react-query';
import { MarketplaceProvider, TolgeeProvider, useTranslate } from '@rakutenfrance/tolgee-provider';
import { publicRuntimeConfig } from '@rakutenfrance/config-service';
import { connect } from 'react-redux';
import { initialAction } from '../initialAction';
import { staticData } from '../../translate/tolgee';
const EconomicOperator = () => {
    const { isVisible } = useEconomicOperatorContext();
    const [isAvailable, setIsAvailable] = useState(false);
    const [isEshop, setIsEshop] = useState(false);
    const [open, setOpen] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [data, setData] = useState();
    const [productId, setProductId] = useState();
    const { breakpoint } = useBreakpoint();
    const { t } = useTranslate('legal-economic-operator');
    const backgroundImage = `https://fr.shopping.rakuten.com/visuels/0_next-common/eshop-header/${breakpoint === 'tablet' || breakpoint === 'phone' ? 'xs' : 'md'}-operator-economic.png`;
    const Api = new DataForEconomicOperatorSellerApi(undefined, '');
    useQuery({
        queryKey: ['getEconomicOperator', productId],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (productId) {
                try {
                    const result = yield Api.getEconomicOperatorData(productId);
                    setData(result.data);
                    if (((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        setIsAvailable(true);
                    }
                }
                catch (err) {
                    console.log(err);
                }
            }
            else {
                return undefined;
            }
        }),
        refetchOnMount: false,
        retry: 2,
        enabled: !!productId && !!shouldFetch,
    });
    const toggleDrawer = useCallback(() => {
        if (!open) {
            setOpen(true);
            setShouldFetch(true);
        }
    }, [open]);
    useEffect(() => {
        var _a;
        (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (e) => {
            const economicOperatorContainer = e.target.closest('.economicOperatorLink');
            if (economicOperatorContainer) {
                const economicOperatorElem = economicOperatorContainer.getAttribute('data-productid');
                if (economicOperatorElem) {
                    e.preventDefault();
                    const isShopAttr = economicOperatorContainer.getAttribute('data-is-eshop') === 'true';
                    if (isShopAttr) {
                        setIsEshop(isShopAttr);
                    }
                    setProductId(economicOperatorContainer.getAttribute('data-productid'));
                    toggleDrawer();
                }
            }
        });
    }, [toggleDrawer]);
    return (React.createElement(Box, null,
        React.createElement(Typography, { component: 'p', onClick: toggleDrawer, style: { cursor: 'pointer' }, "data-ts": "responsible_person" }, t('responsible_person', "Personne responsable dans l'UE")),
        React.createElement(Drawer, { open: open, titleDataTs: "drawer_title", title: t('drawer_title', 'Détails de conformité du produit'), onClose: () => setOpen(false), PaperProps: { style: { display: 'block' } }, content: isVisible ? (React.createElement(Stack, { padding: "16px" },
                React.createElement(Stack, { gap: 2 },
                    React.createElement(Box, { sx: {
                            width: '100%',
                            height: '120px',
                            borderRadius: '8px',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundImage: `url(${backgroundImage})`,
                        } }),
                    isAvailable ? React.createElement(AvailableContent, { data: data }) : React.createElement(UnavailableContent, { isEshop: isEshop })))) : undefined })));
};
const mapStateToProps = (state) => {
    const { economicOperator } = state;
    return Object.assign({}, economicOperator);
};
const mapDispatchToProps = (dispatch) => ({
    // @ts-expect-error initalAction
    initalAction: (...args) => dispatch(initialAction(...args)),
    dispatch,
});
export const EconomicOperatorModule = (props) => {
    var _a, _b, _c;
    const client = new QueryClient();
    return (React.createElement(TolgeeProvider, { ns: ['legal-economic-operator'], apiKey: (_b = (_a = publicRuntimeConfig.tolgee) === null || _a === void 0 ? void 0 : _a.apiKey) === null || _b === void 0 ? void 0 : _b['next-common'], apiUrl: (_c = publicRuntimeConfig.tolgee) === null || _c === void 0 ? void 0 : _c.apiUrl, staticData: staticData },
        React.createElement(MarketplaceProvider, null,
            React.createElement(QueryClientProvider, { client: client },
                React.createElement(EconomicOperatorContextProvider, null,
                    React.createElement(EconomicOperator, Object.assign({}, props)))))));
};
export const EconomicOperatorContainer = connect(mapStateToProps, mapDispatchToProps)(EconomicOperatorModule);
